import { type ProductData } from "~/domains/product/types/ProductData";

import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import { type ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { transformPdpProduct } from "~/features/productDetails/transformers/PdpPageProductDataTransformer";
import { type PdpPageProductDataDto } from "~/features/productDetails/dto/PdpPageProductDataDto";

export async function fetchProductInfo(productCode: string, details?: boolean): Promise<ProductData> {
  const url = occUrl(`/p/api/${productCode}?details=${details ? "true" : "false"}`);
  const response = await occFetch(url);
  if (!response.ok) {
    throw new Error("Error fetching product");
  }
  const dto = (await response.json()) as ProductDataDTO;
  const product = details ? transformPdpProduct(dto as PdpPageProductDataDto, null) : transformProduct(dto);
  product.isFullProduct = true;
  return product;
}
